module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_simple_rec_3.be062d8d.png";